import { LgvModel } from '../../data-models/longevity.model';
import { Component, Input, OnInit } from '@angular/core';
import { LgvConstants } from '../../core/core.module';

@Component({
    selector: 'lgv-company-copyright',
    template: `&copy; {{currentYear}}  {{companyInfo?.name}}  |  {{licenseOrNmls}}`,
})

export class CompanyCopyrightComponent implements OnInit {
    @Input() companyInfo: LgvModel.CompanyInfo;
    get currentYear(): string { return new Date().getFullYear().toString(); }
    get licenseOrNmls(): string { return LgvConstants.isMortgageLenderBusinessType(this.companyInfo?.businessTypeId) ? this.nmls : this.licNum }

    get nmls(): string { return !!this.companyInfo?.nmlsid ? 'NMLS ' + this.companyInfo.nmlsid : '' }
    get licNum(): string { return !!this.companyInfo?.licenseNumber ? 'License # ' + this.companyInfo?.licenseNumber : '' }

    constructor() {
    }

    ngOnInit() {
    //    console.log('companyInfo:');
    //    console.log(this.companyInfo);
    }
}
